import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const StatusPageWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    img {
        width: 100%;
        height: auto;
    }
`;

export const Header = styled.div`
    ${DESKTOP_SIZES[SIZES.HEADING_XXXL].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XXXL].fontWeight};
    ${DESKTOP_SIZES[SIZES.HEADING_XXXL].lineHeight};
    color: ${TC.heading};
    margin-top: 32px;
    margin-bottom: 8px;
`;

export const Subheader = styled.div<{ topMargin?: number }>`
    ${DESKTOP_SIZES[SIZES.HEADING_XXL].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XXL].fontWeight};
    ${DESKTOP_SIZES[SIZES.HEADING_XXL].lineHeight};
    color: ${TC.heading};
    margin-top: ${({ topMargin }) => (topMargin ? topMargin : 0)}px;
    margin-bottom: 34px;
`;

export const Text = styled.div`
    ${DESKTOP_SIZES[SIZES.BODY_LG].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_LG_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_MD].lineHeight};
    color: ${TC.body};
`;

export const Content = styled.div`
    margin-bottom: 40px;
`;
